import { DefaultApi } from '../../../api';
import { urls } from '../../../urls';
import { Action } from '../../../action';
import { getCatchError } from '../../../getCatchError';

const setGetViewGameFreespin = (params) => {
    return async (dispatch, getState) => {
        try {
            const { data } = DefaultApi({
                params,
                method: 'get',
                url: urls.GET_VIEW_GAME_FS
            });

            if (data.status === 'success') {
                dispatch(Action.SetGetViewGameFreespinAction({
                    ...data.data
                }));
            }
        } catch (error) {
            getCatchError(error)
        }
    }
}

export {
    setGetViewGameFreespin as SetGetViewGameFreespin
}